import api from "../../utils/apiUserCliente";

export const reservarStock = async (items) => {
  const res = await api.post("/api/compras/checkout/reservar", { items });
  return res.data;
};

export const reservaCheckout = async ({ grupo_reserva, telefono, direccion, envio, pago }) => {
  const res = await api.post("/api/compras/checkout/reservar/grupo", {
    grupo_reserva,
    telefono,
    direccion,
    envio,
    pago,
  });
  return res.data;
};

export const crearPaymentIntent = async (grupo_reserva) => {
  const res = await api.post("/api/compras/checkout/payment/crear-intent", { grupo_reserva });
  return res.data;
};

export const crearOrdenPedido = async (grupo_reserva) => {
  const res = await api.post("/api/compras/checkout/pedidos/pendiente", { grupo_reserva });
  return res.data;
};


export const ObtenerPedidoSuccess = async (params) => {
  const res = await api.get("/api/compras/checkout/pedido/success", {
    params,
  });
  const body = res.data;
  if (body?.ok && body.data) {
    return { ok: true, ...body.data };
  }
  return body;
};
